export default __webpack_public_path__ + "static/media/instagram_dark.459d14ac.png";